<template>
  <div class="download">
    <div class="logo">
      <span></span>
      <div>{{$t(langKey+'.name')}}</div>
    </div>
    <div class="bg2">
      <div></div>
    </div>
    <div class="desc">
      <div class="row">{{$t(langKey+'.desc1')}}</div>
      <div class="row">{{$t(langKey+'.desc2')}}</div>
    </div>
    <div class="button-wrap">
      <a @click="download">{{$t(langKey+'.button')}}</a>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { setTitle } from 'components/mixin/title'
export default {
  data() {
    return {
      langKey: this.$route.name
    }
  },
  mixins: [setTitle],
  methods: {
    download() {
      console.log('download')
    }
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .download{
    min-height: 100vh;
    width: 100%;
    background-image: url('~image/bg-download.png');
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    font-size: size(26);
    color: #fff;
    padding-bottom: size(32);
    >.logo{
      text-align: center;
      padding-top: size(98);
      >span{
        display: inline-block;
        width: size(128);
        height: size(128);
        background-image: url('~image/logo.png');
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      >div{
        font-size: size(24);
        margin-top: size(22);
      }
    }
    >.bg2{
      text-align: center;
      margin-top: size(-30);
      >div{
        display: inline-block;
        width: size(550);
        height: size(550);
        background-image: url('~image/bg-download2.png');
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
    >.desc{
      padding: 0 size(60);
      line-height: 1.4;
    }
    >.button-wrap{
      margin-top: size(66);
      text-align: center;
      padding: 0 size(32);
      >a{
        display: block;
        height: size(94);
        line-height: size(94);
        background-color: #F4C3C1;
        -webkit-border-radius: size(47);
        -moz-border-radius: size(47);
        border-radius: size(47);
        font-size: size(30);
        color: #D9251D;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/download.vue